// removed by extract-text-webpack-plugin
module.exports = {"ListNode":"yVNuiA_Pmq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ListSlatePlugin/ListSlatePlugin.scss
// module id = 229
// module chunks = 0